import { ApButtonMain } from '@alixpartners/ui-components';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { ActionButtonsContainer } from './Data.styles';

const LINK_TO_THIRD_PARTY_ALLOCATION = '/allocation/thirdParty';
const LINK_TO_PERSONNEL_ALLOCATION = '/allocation/personnel';

export const LinksToSpendAllocation = ({
  isPersonnel,
  isThirdParty,
  canAllocatePersonnel,
}: {
  isPersonnel?: boolean;
  isThirdParty?: boolean;
  canAllocatePersonnel?: boolean;
}) => {
  const history = useHistory();
  return (
    <ActionButtonsContainer>
      <ApButtonMain
        disabled={!isThirdParty}
        onClick={() => {
          history.push(LINK_TO_THIRD_PARTY_ALLOCATION);
        }}
      >
        Third party spend Allocation
      </ApButtonMain>
      {canAllocatePersonnel && (
        <ApButtonMain
          disabled={!isPersonnel}
          onClick={() => {
            history.push(LINK_TO_PERSONNEL_ALLOCATION);
          }}
        >
          Personnel spend Allocation
        </ApButtonMain>
      )}
    </ActionButtonsContainer>
  );
};
